export default __webpack_public_path__ + "locales/tr/SmartBanner.json?hash=76255da1486449d834e75edf82888773";